export function stickyHeaderPushOffset(
  nextHeaderStart: number,
  scrollTop: number,
  headerHeight: number
): number {
  if (headerHeight <= 0) return 0;
  return Math.max(
    -headerHeight,
    Math.min(0, nextHeaderStart - scrollTop - headerHeight)
  );
}

export function stickySectionExpansionInset(
  visibleTop: number,
  stickyTop: number
): number {
  return Math.max(0, stickyTop - visibleTop);
}
